import React from 'react';
import { useNavigate } from 'react-router-dom';

interface BackButtonProps {
  label?: string;
  className?: string;
  onClick?: () => void;
  to?: string;
  children?: React.ReactNode;
  disabled?: boolean;
}

/**
 * A reusable back button component that navigates to the previous page
 * or calls a custom onClick handler if provided
 */
const BackButton: React.FC<BackButtonProps> = ({ 
  label = 'Back', 
  className = 'btn btn-outline-secondary mb-4',
  onClick,
  to,
  children,
  disabled
}) => {
  const navigate = useNavigate();
  
  const handleGoBack = () => {
    if (onClick) {
      onClick();
    } else {
      navigate(-1); // Navigate to the previous page in history
    }
  };
  
  return (
    <button
      className={`btn btn-outline-secondary ${className}`}
      onClick={handleGoBack}
      disabled={disabled}
      aria-label={`Go back${to ? ` to ${to}` : ''}`}
    >
      <i className="fas fa-arrow-left me-2"></i>
      {children || label}
    </button>
  );
};

export default BackButton; 